import ApplicationContext from "domain/ApplicationContext";
import useApplicationContext from "./apollo/applicationContext/useApplicationContext";

export default function useTimeZone() {
  const applicationContext = useApplicationContext();

  return {
    overrideToSiteTimeZone: (dateTime) => ApplicationContext.overrideToSiteTimeZone(applicationContext, dateTime),
  };
}
